import React from 'react';

import MaterialReactTable, {
  MaterialReactTableProps,
} from 'material-react-table';

import { classNames } from '../utils';

import styles from './StlTable.module.css';

export default function StlTable({
  columns,
  data,
  isLoading = false,
  classes = [],
  ...props
}: { isLoading?: boolean; classes?: string[] } & Partial<
  MaterialReactTableProps<any>
>) {
  return (
    <MaterialReactTable
      layoutMode="grid"
      muiTableContainerProps={{
        className: classNames(styles.stl_table_container, ...classes),
      }}
      muiTablePaperProps={{
        className: styles.stl_table_paper,
      }}
      muiTableProps={{
        className: styles.stl_table,
      }}
      muiTableHeadRowProps={{ className: styles.stl_table_head }}
      columns={columns}
      data={data}
      enableColumnActions={false}
      enableColumnFilters
      enablePagination={false}
      enableSorting
      enableRowActions
      enableTopToolbar={false}
      enableBottomToolbar={false}
      state={{ isLoading }}
      positionActionsColumn="last"
      /* eslint-disable react/jsx-props-no-spreading */
      {...props}
    />
  );
}
